module.exports = __webpack_public_path__ + "static/media/Glazbeno-scenki prikaz-foto 1.5c5ff993.png";